import React from "react";
import logo from "../../assets/logoHeader.png";
import "./styles.scss";

const Loading = () => (
  <div id="preloader">
    <div className="logo-loader">
      <img src={logo} alt="logo" />
    </div>
    <div id="status"></div>
  </div>
);

export default Loading;
